<template>
  <div class="modal fade" id="addComment">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Comment</h5>
        </div>
        <div class="modal-body">
          <div class="form-group row align-items-center">
            <div class="col">
              <input v-model="title" placeholder="Title" class="form-control">
            </div>
          </div>

          <div class="form-group row align-items-center">
            <div class="col">
              <textarea v-model="notes" placeholder="Notes" class="form-control"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button v-on:click="submit" class="btn btn-primary">Add Comment</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "api";

  export default {
    data() {
      return {
        title: '',
        notes: ''
      };
    },
    props: ['project'],
    methods: {
      submit: function() {
        api.createTask({ project_id: this.project.id, title: this.title, notes: this.notes, kind: 'comment'}).then(response => {
          this.title = '';
          this.notes = '';
          $('#addComment').modal('hide')
        });
      }
    }
  }
</script>
